<template>
  <a
    class="dashed-link"
    :href="href"
    @click.prevent="setActiveTab"
  >
    {{ label }}
  </a>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isAdaptiveMode } from '@/mixins'

export default {
  name: 'DashedLink',
  mixins: [isAdaptiveMode],
  props: {
    tabName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      initialOffset: state => state.productTabs.initialOffset
    }),
    href () {
      return window.location.origin + window.location.pathname + '?tab=' + this.tabName
    }
  },
  methods: {
    ...mapActions(['SET_ACTIVE_TAB']),
    setActiveTab () {
      const data = {
        string: this.tabName,
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset - 50
      }
      this.SET_ACTIVE_TAB(data)
    }
  }
}
</script>

<style scoped lang="sass">
.dashed-link
  color: #3e77aa
  font-size: 14px
  border-bottom: 1px dashed #3e77aa
  cursor: pointer
  display: inline-block
  text-transform: uppercase
  letter-spacing: .04em

  &:hover
    border-color: transparent

</style>
